import { css } from "@linaria/core";
import {
  units,
  typographies,
  easings,
  breakpoints,
  scrambledMixin,
  outline,
  fonts,
  colors,
} from "@pm2/compat";

export const descriptionTransitionDurationMs = 200;

export const wrapper = css`
  &:only-child {
    margin-bottom: ${units.px(6)};
  }
`;

export const description = css`
  overflow: hidden;
  overflow-wrap: anywhere;

  display: -webkit-box;

  font-family: ${typographies.detail()};

  transition: height ${descriptionTransitionDurationMs}ms ${easings.outQuad};

  &:not([data-expanded="true"]):not(&-exit):not(&-enter) {
    -moz-line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;

    .${wrapper}:only-child & {
      -moz-line-clamp: 3;
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }

    @media ${breakpoints.mobile.andDown().toQuery()} {
      .${wrapper}:only-child & {
        -moz-line-clamp: 1;
        -webkit-line-clamp: 1;
        line-clamp: 1;
      }

      .${wrapper}:not(:only-child) & {
        height: 0;
      }
    }
  }

  &[data-scrambled="true"] span {
    ${scrambledMixin()};
  }
`;

export const descriptionTogglerWrapper = css`
  margin-top: ${units.px(4)};
  height: ${units.px(22)};

  @media ${breakpoints.mobile.andDown().toQuery()} {
    height: ${units.px(19)};
  }
`;

export const descriptionToggler = css`
  ${outline({ offset: units.px(6) })};

  display: flex;
  align-items: center;
  gap: ${units.px(5)};

  font-family: ${fonts.body({ weight: "medium" })};
  font-size: ${units.font.px(15)};
  line-height: 1;
  text-decoration: underline;
  text-underline-offset: ${units.px(2)};
  color: ${colors.text.secondary()};

  transition: color 0.1s linear;

  vertical-align: top;

  &:hover,
  &:focus-visible {
    color: ${colors.text.primary()};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    font-size: ${units.font.px(14)};
  }
`;
